var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImporty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3956",
    "data-name": "Rectangle 3956",
    width: 24,
    height: 24,
    transform: "translate(60 479)",
    fill: "none",
    stroke: "#ffc400",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4740",
    "data-name": "Mask Group 4740",
    transform: "translate(-60 -479)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7625",
    "data-name": "Group 7625",
    transform: "translate(62.579 481.595)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7624",
    "data-name": "Group 7624",
    transform: "translate(0.422 2.488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8226",
    "data-name": "Path 8226",
    d: "M19.5,31.694V37.3a2.334,2.334,0,0,1-2.334,2.334H3.834A2.334,2.334,0,0,1,1.5,37.3V31.694",
    transform: "translate(-1.5 -25.806)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_806",
    "data-name": "Line 806",
    y2: 10.027,
    transform: "translate(9)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8227",
    "data-name": "Path 8227",
    d: "M29.132,34.162l-3.873,3.873-3.873-3.873",
    transform: "translate(-16.259 -27.637)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImporty);
export default __webpack_public_path__ + "static/media/importy.4b8bba882bac7a11a4486858ddb1d890.svg";
export { ForwardRef as ReactComponent };